import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectOrderById,
  selectOrderIsError,
  selectOrderIsLoading,
} from "../../redux/state/orders/orders.selectors";
import { useParams, useNavigate } from "react-router-dom";
import { fetchOrderById } from "../../redux/state/orders/orders.fetch";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  Fade,
  Collapse,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Loader from "../../Components/Loader/Loader";
import OrderDetails from "../../Components/OrderDetails/OrderDetails";
import OrderCopyLink from "../../Components/OrderCopyLink/OrderCopyLink";
import OrderActions from "../../Components/OrderActions/OrderActions";
import Notiflix from "notiflix";
import { fetchRates } from "../../redux/state/rates/ratesSlice";
import { operator } from "../../srevices/contacts";

function Orders() {
  const dispatch = useDispatch();
  const orderDetails = useSelector(selectOrderById);
  const isError = useSelector(selectOrderIsError);
  const isLoading = useSelector(selectOrderIsLoading);
  const { orderId } = useParams();

  const theme = useTheme();
  const navigate = useNavigate();

  const [orderLink] = useState(window.location.href);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const [showPaymentInstruction, setShowPaymentInstruction] = useState(false);

  const togglePaymentInstruction = () => {
    setShowPaymentInstruction((prev) => !prev);
  };

  useEffect(() => {
    dispatch(fetchOrderById(orderId));
    dispatch(fetchRates());
  }, [dispatch, orderId]);

  useEffect(() => {
    if (isError) {
      Notiflix.Notify.failure("Заявка не найдена");
      navigate("/");
    }
  }, [isError, navigate]);

  if (isError) {
    return <Typography variant="h6">Заявка не найдена</Typography>;
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Box sx={{ marginTop: 3 }}>
      <Fade in={true} timeout={1000}>
        <Card>
          <CardContent>
            <Divider sx={{ marginBottom: 2 }} />
            <OrderDetails
              orderDetails={orderDetails}
              theme={theme}
              handleCopy={handleCopy}
            />
            <Divider sx={{ marginBottom: 3 }} />
            <OrderCopyLink orderLink={orderLink} handleCopy={handleCopy} />
            <OrderActions theme={theme} />

            <Button
              variant="outlined"
              color="primary"
              onClick={togglePaymentInstruction}
              sx={{ marginTop: 2, width: "100%", fontWeight: "bold" }}
            >
              Инструкция по оплате
            </Button>

            <Collapse in={showPaymentInstruction}>
              <Box
                sx={{
                  marginTop: 2,
                  padding: 2,
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: 1,
                }}
              >
                {/* Если оплата по карте */}
                {orderDetails?.paymentMethod === "По карте + комиссия " ? (
                  <>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      <strong>Инструкция для оплаты по карте:</strong>
                    </Typography>
                    <a
                      href="https://telegra.ph/Kak-oplatit-na-sajte-po-karte-ili-SBP-03-12"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        color: "#ff5733", // Яркий цвет для выделения
                        textDecoration: "underline", // Подчеркивание
                        fontWeight: "bold",
                        fontSize: "18px", // Увеличенный шрифт для лучшей видимости
                      }}
                    >
                      НАЖМИ ЕСЛИ НЕ ПОНЯТНО, ТУТ ПОЛНАЯ ИНСТРУКЦИЯ С ФОТО
                    </a>
                    <Typography
                      variant="body2"
                      color="error"
                      paragraph
                      sx={{ fontWeight: "bold", fontSize: "16px" }}
                    >
                      ВНИМАНИЕ!!! ПЕРЕХОДИТЬ ТОЛЬКО ПО КНОПКЕ И ОПЛАИЧВАТЬ РОВНО
                      ТУ СУММУ ЧТО НАПИСАНО В ЗАЯВКЕ
                    </Typography>
                   
                    <Typography variant="body2" color="textSecondary" paragraph>
                      1. Жмем кнопку "Перейти к оплате", вас перенаправит в бот
                      для оплаты.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      2. Пройдите капчу в боте и выберите "Баланс".
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      3. Нажмите на кнопку "Пополнить баланс" и введите сумму,
                      указанную на сайте в заявке.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      4. Выберите удобный способ оплаты и завершите процесс.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      5. Когда оплата будет завершена и деньги поступят на
                      баланс, бот автоматически спишет нужную сумму и
                      предоставит ссылку на товар в боте.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      6. Если баланс пуст, но вы пополнили его, нажмите
                      "Продлить заявку" и обратитесь в{" "}
                      <a
                        href={operator}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#1a73e8",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Telegram
                      </a>
                      .
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      <strong>Оплатите на кошелек</strong> не позднее указанного
                      времени. Если не хватает времени — продлите, пожалуйста.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      <strong>
                        ОБЯЗАТЕЛЬНО СОХРАНИТЕ СЕБЕ ССЫЛКУ В ИЗБРАННОЕ, ПОКА ОНА
                        АКТИВНА, ТОЛЬКО ПО НЕЙ ВЫ СМОЖЕТЕ ИМЕТЬ ДОСТУП К ЗАЯВКЕ
                      </strong>
                    </Typography>
                    <Typography variant="body2" color="textSecondary" paragraph>
                      После оплаты ничего делать не нужно. Выдача производится в
                      автоматическом режиме.
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Если после оплаты прошло 15 минут и вы все еще не получили
                      адрес, обратитесь в поддержку через{" "}
                      <a
                        href={operator}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#1a73e8",
                          textDecoration: "none",
                          fontWeight: "bold",
                        }}
                      >
                        Telegram
                      </a>
                      .
                    </Typography>
                  </>
                )}
              </Box>
            </Collapse>
          </CardContent>
        </Card>
      </Fade>
    </Box>
  );
}

export default Orders;
